import React from 'react';

const StarRating = ({ rating, maxRating = 5 }) => {
  // Don't render anything if rating is null, undefined, or 0
  if (rating === null || rating === undefined || rating === 0) {
    return null;
  }
  
  return (
    <div className="star-rating">
      {[...Array(maxRating)].map((_, i) => (
        <span 
          key={i} 
          className={`star-rating__star ${i < rating ? '' : 'star-rating__star--empty'}`}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating; 